/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Filename: monthly-bar-graph-component.ts
 *
 * Created by randysorensen on 2019-02-22.
 */

function MonthlyBarGraphController (
    this: JS5Object,
    _: JS5Object,
    DynamicPropertiesService: JS5Object,
    MetricsDashboardService: JS5Object,
    UtilsService: JS5Object
) {

    const createTooltip = (tooltipData: JS5Object) => {
        let tooltip = `<div class="text-align-left">`;
        tooltip += `${tooltipData.title}<br/><hr/>`;
        _.forEach(tooltipData.lines, (line: string) => {
            tooltip += `${line}<br/>`;
        });
        return tooltip;
    };

    const createBars = (timeStamp: Date, metricsData: JS5Object, tooltipData: JS5Object) => {
        const prismBarGraphBlue = '#43A6DC';
        const prismBarGraphGreen = '#26CA00';

        let today = new Date();

        let bars: JS5Object = {};

        let keys = _.keys(metricsData).sort();
        _.forEach(keys, (key: string) => {
            let keyAsInt = parseInt(key);
            let bar: JS5Object = {};
            bar.year = _.floor(keyAsInt / 100);
            bar.month = _.floor(keyAsInt % 100);
            bar.label = UtilsService.constants.MONTHS[bar.month - 1].substring(0, 3);
            bar.value = parseFloat(metricsData[key]);
            bar.tooltip = createTooltip(tooltipData[key]);
            bar.tooltipClass = tooltipData[key].tooltipClass;
            if (today.getFullYear() === bar.year && today.getMonth() + 1 === bar.month) {
                bar.color = prismBarGraphGreen;
            } else {
                bar.color = prismBarGraphBlue;
            }
            bars[key] = bar;
        });

        return bars;
    };

    //
    // Memoize the bar array based on the data timestamp.
    //
    const memoizedCreateBars = _.memoize(
        createBars,
        (timeStamp: Date, metricsData: JS5Object, tooltipData: JS5Object) => _.invoke(timeStamp, 'getTime')
    );

    const barGraphDataUpdated = (metricsData: JS5Object) => {
        let barGraphData = _.get(metricsData, this.monthlyDatasetProperty, {});
        let tooltipData = _.get(metricsData, 'tooltipData', {});
        this.monthlyBarGraphData = {
            bars: memoizedCreateBars(metricsData.timeStamp, barGraphData, tooltipData),
            animationDuration: DynamicPropertiesService.getPropValueAsInt('metrics.animationTime', 0.5),
            timeStamp: metricsData.timeStamp
        };
    };

    this.$onInit = () => {
        this.monthlyBarGraphData = {};
        DynamicPropertiesService.queryForProperties()
        .then(() => {
            MetricsDashboardService.registerDataUpdateCallback(barGraphDataUpdated);
        });
    };

}

angular.module('prism-ui.metricsDashboard').component('monthlyBarGraph', {
    controller: MonthlyBarGraphController,
    templateUrl: 'dashboard/metrics/dashboard-panels/monthly-bar-graph/monthly-bar-graph-template.html',
    bindings: {
        monthlyDatasetProperty: '<'
    }
});
